import accordion from "./components/accordion";
accordion();
import modal from "./components/modal";
modal();
// import video from "./components/video";
// video();
import AOSinit from "./components/AOSinit";
AOSinit();
import sliders from "./components/sliders";
sliders();
import * as burger from './functions/burger';
burger;